import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import VS from "../../../../../../assets/images/fanGroup/VS.png";
import FanGroupIcon from "../../../../../../assets/images/iconFan/expired-1.png";
// import shahRukhAnother from "../../../../../../assets/images/starImg/shahRukhAnother.webp";
import { Markup } from "interweave";
import "./CompletionBetweenStars.css";
import fan from "../../../../../../assets/images/fanGroup/Maskgroup.png";
import { serverInfo } from "../../../../../../App";

import noImage from "../../../../../../assets/images/settings/no-image.png";
const CompetitionBetweenStars = () => {
  const { imageCdnUrl } = useContext(serverInfo);

  let history = useHistory();
  const { slug } = useParams();

  const [fanDetails, setFanDetails] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanDetails(res.data.fanDetails);
      }
    });
  }, [slug]);

  return (
    <>
      <div className="mx-2 card bg-black p-3 px-4">
        <div className="d-flex my-2">
          <img className="img-fluid" width="35px" src={FanGroupIcon} alt="" />
          <h3 className="text-white mx-2">Pending Fan Group</h3>
        </div>
        <div className="row">
          <div className="col-md-12 card card-bg p-0 fanPo rounded-3 border-warning">
            <img src={fan} alt="" style={{ minHeight: 200 }} />
            <div className="fanpso fanGroupText">
              <h4 className="pendingTxt">PENDING</h4>
              <h2 className="fanGroupTxt">FAN GROUP</h2>
            </div>
          </div>
        </div>

        <div className="row my-4">
          <div className="col-md-11 text-light">
            <h2 className="text-warning fw-bold">
              <i>{fanDetails.group_name} </i>
            </h2>
            <p>
              <Markup content={fanDetails.description} />
            </p>
          </div>
        </div>

        <div className="row my-4">
          <div className="col-md-7 row">
            <div className="col-md-5 my-2">
              <div class="card card-bg snip1527">
                <div class="image">
                  <img
                    claName=" img-fluid"
                    src={
                      fanDetails.my_superstar?.image
                        ? imageCdnUrl + fanDetails.my_superstar?.image
                        : noImage
                    }
                    alt="pr-sample23"
                  />
                </div>
                <figcaption>
                  <h3>
                    {fanDetails.my_superstar?.first_name}{" "}
                    {fanDetails.my_superstar?.last_name}
                  </h3>

                  <p>
                    <big>
                      <span className="text-light">Status</span>:
                      <i className="text-warning">Accepted</i>
                    </big>
                  </p>
                </figcaption>
              </div>
            </div>
            <div className="col-md-2 my-2 d-flex justify-content-center align-items-center">
              <img className="img-fluid" src={VS} alt="" />
            </div>
            <div className="col-md-5 my-2">
              <div class="card card-bg snip1527">
                <div class="image">
                  <img
                    claName="img-fluid"
                    src={
                      fanDetails.another_superstar?.image
                        ? imageCdnUrl + fanDetails.another_superstar?.image
                        : noImage
                    }
                    alt="pr-sample23"
                  />
                </div>
                <figcaption>
                  <h3>
                    {fanDetails.another_superstar?.first_name}{" "}
                    {fanDetails.another_superstar?.last_name}
                  </h3>

                  <p>
                    <big>
                      <span className="text-light">Status</span>:
                      <i className="text-warning">Accepted</i>
                    </big>
                  </p>
                </figcaption>
              </div>
            </div>
          </div>

          <div className="col-md-5 d-flex justify-content-center align-content-center">
            <div>
              <h3 className="text-light text-center my-3">
                <i className="fw-bolder">Status</i>
              </h3>
              {Number(fanDetails.status) === 1 ? (
                <div className="">
                  <div className="bg-dark bgBorderManagerAuth py-2 px-5 d-flex">
                    <div class="containerR">
                      <div class="checkmarkR  checkmark--inverted">
                        <div class="checkR"></div>
                      </div>
                    </div>
                    <div className="ps-4">
                      <p className="text-light">Manager Authentication</p>
                      <h3 className="text-warning">Published</h3>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <div className=" bgBorderManagerAuth py-2 px-5 d-flex">
                    {/* <div className="spinnerBootstrap">
                    <div className="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div> */}

                    <div class="center d-flex">
                      <div class="parent-spinner">
                        <div
                          class="spinner spinner-rotate border-spinner-yellow"
                          data-mx-time="0.6"
                        ></div>
                      </div>
                    </div>

                    <div className="ps-4">
                      <p className="text-light">Manager Authentication</p>
                      <h3 className="text-warning">Waiting for Publish</h3>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompetitionBetweenStars;
